import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getLoggedinUser } from '../../helpers/api_helper';

const useProfile = () => {
  const reduxUser = useSelector(state => state.Login?.user);
  const sessionUser = getLoggedinUser();

  const initialUser = reduxUser || sessionUser;
  const [userProfile, setUserProfile] = useState(initialUser);
  const [loading, setLoading] = useState(true); // Start with loading true
  const [token, setToken] = useState(initialUser?.token || null);

  useEffect(() => {
    const updatedUser = reduxUser || getLoggedinUser();
    setUserProfile(updatedUser);
    setToken(updatedUser?.token || null);
    setLoading(false);
  }, [reduxUser]);

  return {
    userProfile,
    loading,
    token,
  };
};

export { useProfile };
